<mat-icon (click)="clearInput()">clear</mat-icon>
